// src/pages/Logout.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    // Nettoyer le localStorage
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('skin-mode');
    localStorage.removeItem('sidebar-skin');
    
    // Rediriger vers la page de connexion
    setTimeout(() => {
      navigate('/login');
    }, 1000);
  }, [navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="text-center">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3">Déconnexion en cours...</p>
      </div>
    </div>
  );
}